module.exports = __webpack_public_path__ + "img/notifi-success.d47434f5.svg";